import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { KTIcon } from "../../../_metronic/helpers";

interface Props {
  name?: string;
  style: string;
}

export const IconsCard: FC<Props> = ({ name, style }) => {
  const intl = useIntl();

  const [icon, setIcon] = useState<string | undefined>(undefined);

  const VERIFICATION = intl.formatMessage({ id: "DEAL_CARD_VERIFICATION" });
  const ACCOUNT = intl.formatMessage({ id: "DEAL_CARD_ACCOUNT" });
  const INFO = intl.formatMessage({ id: "DEAL_CARD_INFO" });
  const DEPOSIT = intl.formatMessage({ id: "DEAL_CARD_DEPOSIT" });
  const OTHERS = intl.formatMessage({ id: "DEAL_CARD_OTHERS" });
  const DESIGN = intl.formatMessage({ id: 'DEAL_CARD_DESIGN' });
	const DEVELOPMENT = intl.formatMessage({ id: 'DEAL_CARD_DEVELOPMENT' });
	const DOCUMENTS = intl.formatMessage({ id: 'DEAL_CARD_DOCUMENTS' });
	const GAMING = intl.formatMessage({ id: 'DEAL_CARD_GAMING' });
	const CURRENCY = intl.formatMessage({ id: 'DEAL_CARD_CURRENCY' });
	const COLLATERAL = intl.formatMessage({ id: 'DEAL_CARD_COLLATERAL' });

  useEffect(() => {
    if (name) {
      switch (name) {
        case VERIFICATION:
          setIcon("fingerprint-scanning");

          break;
        case ACCOUNT:
          setIcon("faceid");

          break;
        case INFO:
          setIcon("artificial-intelligence");

          break;
        case DEPOSIT:
          setIcon("dollar");

          break;
        case OTHERS:
          setIcon("rocket");
          break;

        case DESIGN:
          setIcon("design");
          break;

        case DEVELOPMENT:
          setIcon("laptop");
          break;

        case DOCUMENTS:
          setIcon("book");
          break;

        case GAMING:
          setIcon("keyboard");
          break;

        case CURRENCY:
          setIcon("dollar");
          break;

        case COLLATERAL:
          setIcon("lock");
          break;
      }
    }
  }, [name]);

  return (
    <>
      <KTIcon iconName={`${icon}`} className={style} />
    </>
  );
};
